export default "__VITE_ASSET__adcf6835__"